import MarketToolsPanel from '@/components/feature/MarketToolsPanel';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import BrokerPopupAd from '@/components/feature/BrokerPopupAd';

const websiteStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'FXCostGuide',
  url: import.meta.env.VITE_SITE_URL || 'https://fxcostguide.com',
  description: 'Independent forex trading cost education — spread, commission, swap, slippage, and hidden fees explained with real numbers and zero broker bias.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: (import.meta.env.VITE_SITE_URL || 'https://fxcostguide.com') + '/?s={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteStructuredData) }}
      />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <BrokerPopupAd />
      <MarketToolsPanel />
    </>
  );
}